import type { LogEvent } from "../types";
import { utcShort, ago } from "../format";

const ICON: Record<string, string> = {
  open: "▲", close: "✕", signal: "⊳", scan: "·", error: "⚠",
};

export default function ActivityLog({ events, label, showInstrument }:
  { events: LogEvent[]; label?: string; showInstrument?: boolean }) {
  if (!events || events.length === 0)
    return <p className="muted">No activity logged yet{label ? ` for ${label}` : ""}.</p>;

  return (
    <div className="log" role="log" aria-label={`Activity log${label ? ` for ${label}` : ""}`} aria-live="polite" tabIndex={0}>
      <ol>
        {events.map((e) => (
          <li key={e.id} className={`log-row kind-${e.kind}`}>
            <span className="log-icon" aria-hidden="true">{ICON[e.kind] ?? "·"}</span>
            <time className="log-time" dateTime={e.ts} title={ago(e.ts)}>{utcShort(e.ts)}</time>
            {showInstrument && e.instrument && <span className="log-inst">{e.instrument}</span>}
            <span className="log-msg">{e.message}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
